import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  footer: {
    backgroundColor: '#fff',
    borderTop: `1px solid ${Common.borderColor}`,
    height: Common.footerHeight,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '0.8em',
    lineHeight: '1.4'
  },
  companyInfo: {
    order: '0',
    marginRight: 'auto',
    paddingLeft: '15px',
    display: 'flex',
    flexDirection: 'column'
  },
  copyrightInfo: {
    order: '2',
    marginLeft: 'auto',
    paddingRight: '40px'
  },
  termsLink: {
    textDecoration: 'underline',
    textTransform: 'uppercase',
    cursor: 'pointer'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Footer/styles.js